import gql from 'graphql-tag';

export default gql`
	mutation AccountContactDelete($_id: ID!) {
		accountContactDelete(_id: $_id) {
			succeed
		}
	}
`;
